module.exports = __webpack_public_path__ + "static/media/onmap.fa533321.png";